// @flow

const isEmptyFile = (value: any): boolean => {
  return value && value.name === '' && value.size === 0;
};

export default isEmptyFile;
